import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { AddTechdocsStyling } from './AddTechdocsStyling';

export const techdocsAddonCustomStylingPlugin = createPlugin({
  id: 'techdocs-addon-custom-styling',
});

export const CustomTechdocsStyling = techdocsAddonCustomStylingPlugin.provide(
  createTechDocsAddonExtension({
    name: 'CustomTechdocsStyling',
    location: TechDocsAddonLocations.Content,
    component: AddTechdocsStyling,
  }),
);
